/** `2026-03-05` → `05/03/2026`. Rỗng / null / lạ → chuỗi rỗng (ô trống, không bịa ngày). */
export function formatDay(iso: string | null | undefined): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso ?? '');
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
}

/** Hôm nay theo giờ máy người dùng, dạng `yyyy-MM-dd` (so chuỗi với cột `date` của DB). */
export function todayIso(now: Date = new Date()): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())}`;
}

/** Đã nghỉ việc: có ngày nghỉ và ngày đó đã qua (ngày nghỉ là ngày làm cuối, nên hôm nay vẫn tính đang làm). */
export const hasLeft = (p: { endDate: string | null }, today: string): boolean => p.endDate !== null && p.endDate < today;
